import React from "react";
import { useTranslation } from "react-i18next";
import StatusChip, { ChipTone } from "components/tw/status-chip";
import { AssetRequestStatus } from "types/AssetRequest";

const CHIP_TONE: Record<AssetRequestStatus, ChipTone> = {
  pending: "amber",
  done: "green",
  rejected: "red",
};

/** `label` replaces the plain status name where the line says more («Įvykdytas 2026-10-12»). */
export default function AssetRequestStatusChip({ status, label }: { status: AssetRequestStatus; label?: string }) {
  const { t } = useTranslation();
  return <StatusChip tone={CHIP_TONE[status]}>{label || t(`asset_requests_status_${status}`)}</StatusChip>;
}
